import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { WebcamImage } from 'ngx-webcam';
import { AppServiceManager } from "../../../common/services/appServiceManager";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import globalVariable from "../../../globalVariable/globalVariable.json";
import branches from '../../shared/data/branches.json';
import cities from '../../shared/data/cities.json';
import { AppUtils } from 'common/services/app.util';
import { Configuration } from 'config/config';
@Component({
  selector: 'registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent {

  public webcamImage: WebcamImage = null;

  currentindex: any;
  errorExempleNumber: string;
  imageChangedEvent: any = "";
  // isCovidVaccinated: boolean = true;
  // covidCardChangedEvent: any = "";
  CNICChangedEvent: any;
  isDisableOnTypeEmail: boolean;
  timer: any;
  isEmailExist: boolean = false;
  isEmailLoader: boolean = false;
  resendSuccess: boolean = false;
  activeIndex: any;
  profileUrl: any;
  // covidImageUrl: any;
  CNICImageUrl: any;
  otpError: string;
  otpErrorMessage: string;
  mobile: number;
  emailAddress: string;
  requestGuid: string;
  company: any;
  branch: any;
  selectedCity = 'Islamabad';
  gender = "M";
  gender2 = "M";
  isSuccess: boolean;
  isError: boolean;
  message: string;
  profileErrorMessage: string;
  selectedBranch: any;
  branches = branches;
  cities = cities;
  OTPHeading: string;
  loading: boolean;
  isMessage: boolean;
  requestId: any;
  branchDetail: any;
  branchContact: any;
  requesterName: any;


  // cities = [
  //   "Islamabad",
  //   "Rawalpindi"
  // ]

  constructor(
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    private loader: NgxSpinnerService,
    public config: Configuration,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe(params => {
        console.log('company:', params.get('company'));
        console.log('branch:', params.get('branch'));
        this.company = params.get("company");
        this.branch = params.get("branch");
        this.getBranchById();

        this.branches = this.branches.filter(branch => branch._id == this.branch);
        if (this.branches.length > 0) {
          this.selectedBranch = this.branches[0];
        }
      });

    this.activeIndex = 0;
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;
  }

  ////////////////////////////////////////

  /////////////////////////////////////////
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: any) {
    this.profileUrl = AppUtils.base64ToFile(event.base64, this.imageChangedEvent.target.files[0].name + ":" + this.company + ":" + this.branch);
  }
  getBranchById() {
    this.loading = true;
    this.appServiceManager.get('branches/'+ this.branch).subscribe((res) => {
      if (res) {
        this.branchDetail= res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  finish() {
    console.log(this.profileUrl);
    this.loading = true;
    // this.profileUrl.name = this.profileUrl.name + this.company;
    // console.log(this.profileUrl);
    if (this.profileUrl) {
      this.upload(this.profileUrl, 'profile');
      this.profileErrorMessage = '';
    }
    else {
      this.loading = false;
      this.activeIndex++;
    }
  }
  /////////////////////////////////
  // covidChangeEvent(event: any): void {
  //   this.covidCardChangedEvent = event;
  // }
  // covidCropped(event: any) {
  //   this.covidImageUrl = AppUtils.base64ToFile(event.base64, this.covidCardChangedEvent.target.files[0].name + ":" + this.company + ":" + this.branch);
  // }

  // covidFinish() {
  //   console.log(this.covidImageUrl);
  //   if (this.covidImageUrl) {
  //     this.upload(this.covidImageUrl, 'covid');
  //     this.profileErrorMessage = '';
  //   }
  //   else {
  //     this.loading = false;
  //     this.activeIndex++;
  //   }


  // }
  /////////////////////////////////
  CNICChangeEvent(event: any): void {
    this.CNICChangedEvent = event;

  }
  CNICCropped(event: any) {
    this.CNICImageUrl = AppUtils.base64ToFile(event.base64, this.CNICChangedEvent.target.files[0].name + ":" + this.company + ":" + this.branch);
  }

  CNICFinish() {
    console.log(this.CNICImageUrl);
    if (this.CNICImageUrl) {
      this.upload(this.CNICImageUrl, 'CNIC');
      this.profileErrorMessage = '';
    }
    else {
      this.loading = false;
      this.activeIndex++;
    }

  }
  ////////////////////////////////////
  Next() {
    this.activeIndex++;
  }

  resendOTP() {
    this.loading = true;
    let payload = {
      request: this.requestGuid,
      mobile: this.mobile,
      company: this.company,
      branch: this.branch
    }
    this.appServiceManager
      .post("OTPs", payload)
      .subscribe(
        (_res: any) => {
          this.resendSuccess = true;
          this.loading = false;
          this.OTPHeading = `New OTP has been sent to your Mobile Number ${this.mobile}`;
        },
        (error: any) => {
          this.loading = false;
          this.isError = true;
          this.otpErrorMessage = "Sorry, Something went wrong.";
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
  }

  verifyOTP(OTP) {
    this.loading = true;
    let payload = {
      mobile: this.mobile,
      OTP: OTP
    }
    this.appServiceManager
      .post("OTPs/validate", payload)
      .subscribe(
        (_res: any) => {
          if (_res.isValid == true) {
            this.activeIndex++;
            this.loading = false;
          }
          else {
            this.otpError = "The OTP you entered is invalid, please try again.";
            this.loading = false;
            this.isError = true;
          }
        },
        (error: any) => {
          this.loading = false;
          this.isError = true;

          this.otpErrorMessage = "Sorry, Something went wrong.";
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
  }

  // covidYes() {
  //   this.activeIndex++;
  //   this.isCovidVaccinated = true;
  //   console.log(this.isCovidVaccinated);
  // }
  // covidNo() {
  //   this.activeIndex += 2;
  //   this.isCovidVaccinated = false;

  // }

  ///////////////////////////////////////////
  errorMsgClose() {
    this.isMessage = false;
  }


  submit(form: any) {
    if (form.valid) {
    this.loading = true;
    this.gender2 = this.gender;
    console.log(form.value);

    this.mobile = form.value.mobile;
    this.requesterName = form.value.name;
    let payload = form.value;

    payload['membershipNumber'] = "123";
    payload['gender'] = this.gender;
    payload['company'] = this.company;
    payload['branch'] = this.branch;

    console.log(this.gender);

    this.appServiceManager
      .post("requests/Registration", payload)
      .subscribe(
        (_res: any) => {
          if (_res.status === true) {
            this.requestId = _res.registration.requestId
            this.requestGuid = _res.registration._id;
            this.message = "You are successfully registered. ";
            this.isSuccess = true;
            this.isError = false;
            this.isMessage = true;

            form.reset();
            this.OTPHeading = `An OTP has been sent to your Mobile Number ${this.mobile}`;
            this.activeIndex = 2;
          } else {
            this.message = "Sorry, Please contact your administrator.";
            this.isSuccess = false;
            this.isError = true;
            this.isMessage = true;
          }
          this.loading = false;
        },
        (error: any) => {
          this.loading = false;
          this.isMessage = true;
          this.isSuccess = false;
          this.isError = true;
          this.message = "Sorry, Please contact your administrator.";
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
    }
    else {
        //  // Form validation error handling
        Object.keys(form.controls).forEach(controlName => {
            const control = form.controls[controlName];
            control.markAsTouched(); // Mark the control as touched to display the validation error messages
        });
    }
  }

  /////////////////////////////////
  checkEmailExistEvent(e) {
    this.isDisableOnTypeEmail = true;
    if (e.target.value.length > 0) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.checkEmailExistence()
      }, 1000);
    } else {
      clearTimeout(this.timer);
      this.isEmailExist = false;
      this.isDisableOnTypeEmail = false;
    }
  }

  checkEmailExistence() {
    if (this.emailAddress != undefined && this.emailAddress.length > 0) {
      this.isEmailLoader = true;
      let data = { email: this.emailAddress, company: this.company, branch: this.branch };
      this.appServiceManager.post("customers/checkEmailExistence", data).subscribe(
        (data: any) => {
          if (data.isEmailExist) {
            this.isEmailExist = true;
            this.isDisableOnTypeEmail = true;
            setTimeout(() => {
              this.isEmailLoader = false;

            }, 1000);
          } else {
            this.isEmailExist = false;
            this.isDisableOnTypeEmail = false;

            setTimeout(() => {
              this.isEmailLoader = false;
            }, 2000);
          }
        },
        (error) => { }
      );
    }
  }
  ////////////////////////////////

  openWhatsApp(): string {

    let reciever = this.branchDetail.whatsapp;
    if (this.branchDetail.whatsapp) {

        let msg = this.config.registrationMessage;
        msg = msg.replace("{0}", this.requestId);
        msg = msg.replace("{1}", this.requestGuid);
        msg = msg.replace("{2}", this.requesterName);

        const message = encodeURIComponent(msg);

            const link = document.createElement('a');
            link.href = `https://wa.me/${reciever}?text=${message}`;
            link.target = '_blank';
            link.click();
            return '';
    } else {
        // Show error message here
        this.messageService.clear();
        this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: 'This user does not have a phone number',
        });
        return '';
    }
}

  upload(file, type) {
    this.loading = true;
    let formData: FormData = new FormData();
    if (file) {
      let isThumb: boolean = true;
      if (type == 'profile') {
        formData.append("customerImage", file, file.name);
        formData.append("isThumb", isThumb.toString());
      }
      // else if (type == 'covid') {
      //   formData.append("covidImage", file, file.name);
      //   formData.append("isCovidVaccinated", this.isCovidVaccinated.toString());
      // }
      else if (type == 'CNIC') {
        formData.append("CNICImage", file, file.name);
      }

      console.log("formData", formData)
      console.log("type", type)

      formData.append("requestGuid", this.requestGuid);
      formData.append("company", this.company);
      formData.append("branch", this.branch);

      this.appServiceManager.post("requests/upload/" + type, formData)
        .subscribe(
          (res: any) => {

            if (res.status === true) {
              this.activeIndex++;
              this.loading = false;
              this.isSuccess = true;
              this.isError = false;
            } else {
              this.profileErrorMessage = "Sorry, Please contact your administrator.";
              this.loading = false;
              this.isSuccess = false;
              this.isError = true;
            }
          },
          (error: any) => {
            //this.MessageService.clear();
            this.isError = true;
            this.profileErrorMessage = "Sorry, Please contact your administrator.";
            this.loading = false;
            this.messageService.add({
              severity: "error",
              summary: "Error Message",
              detail: error,
            });
          }
        );
    }
  }
}
